  <div class="filtro-mapa dropdown-arrow" [style]="'--width:' + width + 'em;'">
    <img [src]="imgSrc" [alt]="alt">
    <select class="campo-input" (change)="pegarValorAtual($event)">
        <option [value]="null">{{ label }}</option>
        <option *ngFor="let dado of dadosSelect" [value]="dado.id">{{ dado.label }}</option>
    </select>
</div>